export default __webpack_public_path__ + "static/media/arena_3.242b088c.jpeg";